<template>
  <unroll-element
    :title="stringified_dict(metavariables_poid)"
    :available="feature_importance_instantiated"
    :start-opened="feature_importance_instantiated"
  >
    <div v-if="feature_importance_instantiated">
      <b-card-group deck>
        <b-card class="text-center">
          <chart :initial_chart_context="context" />
        </b-card>
      </b-card-group>

      <b-table
        responsive
        striped
        hover
        :items="feature_importance_table_items"
        :fields="feature_importance_table_fields"
        class="synaplus-cosmo-scroll-higher-720"
      />
    </div>
  </unroll-element>
</template>

<script>
import _ from 'lodash'

import { round_value } from '@/utils.js'

import {
  brick_mixin,
  subscription_mixin,
  metavariables_tracking_info_mixin,
  brick_generic_modelgenerator_tracking_info_mixin,
} from '@/components/mixin.js'

import UnrollElement from './unroll_element.vue'
import Chart from './chart.vue'
import Chart_class from './chart_class.js'
import Chart_context from './chart_context.js'

// *****************************************************************************

export default {
  name: 'BrickGenericModelgeneratorSubcomponentFeatureImportance',
  components: {
    UnrollElement,
    Chart,
  },

  data() {
    return {
      feature_importance_table_fields: [
        {
          key: 'name',
          label: this.$t('column_name'),
          class: 'text-center',
        },
        {
          key: 'imp',
          label: this.$t('importance'),
          class: 'text-center',
        },
      ],
    }
  },

  mixins: [
    brick_mixin,
    subscription_mixin,
    metavariables_tracking_info_mixin,
    brick_generic_modelgenerator_tracking_info_mixin,
  ],
  props: ['brick_id', 'project_id', 'metavariables_poid'],

  computed: {
    _() {
      return _
    },

    feature_importance_tracking_info() {
      return this.metavariables_tracking_info.feature_importance || {}
    },

    feature_importance_table_items() {
      let res = []
      const feature_imp = this.feature_importance_tracking_info.final || []
      for (const t of feature_imp) {
        let name, imp
        ;[name, imp] = t
        imp = round_value(imp)
        res.push({ name, imp })
      }

      return res
    },

    context() {
      const classes = []

      const feature_imp = this.feature_importance_tracking_info.final || []
      for (const t of feature_imp) {
        let name, imp
        ;[name, imp] = t
        classes.push(new Chart_class(name, imp))
      }

      const res = new Chart_context({
        title: this.$t('feature_importance'),
        type: 'horizontalBar',
        classes: classes,
      })

      return res
    },

    feature_importance_instantiated() {
      return !_.isEmpty(this.feature_importance_tracking_info)
    },
  },
  watch: {
    feature_importance_instantiated: {
      immediate: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, ov)) {
          if (nv) {
            this.$emit('is_instantiated')
          }
        }
      },
    },
  },
}
</script>
